App.directive('loading', function () {
    return {
        restrict: 'E',
        replace:true,
        template: '<div class="loading"><img class="loading-img" src="img/Spinner.gif"><div class="loading-text">Loading...</div></div>',
        link: function (scope, element, attr) {
            scope.$watch('loading', function (val) {
                if (val)
                    $(element).show();
                else
                    $(element).hide();
            });
        }
    }
});

App.directive('loadingModel', function () {
    return {
        restrict: 'E',
        replace:true,
        template: '<div class="loadingmodel"><img class="loading-img" src="" alt=""><div class="loading-text-model">Loading...</div></div>',
        link: function (scope, element, attr) {
            scope.$watch('loadingModel', function (val) {
                if (val)
                    $(element).show();
                else
                    $(element).hide();
            });
        }
    }
});